import React from 'react'
import './Navbar.css'
import { NavLink } from 'react-router-dom'

export default function Navbar() {
	return (
		<div id='navbarFlexContainer'>
			<div id='panelFlexContainer'>
				<NavLink className='usersLink' to='users'>
					Benutzer
				</NavLink>
				<NavLink className='permissionsLink' to='groups'>
					Nutzergruppen
				</NavLink>
				<NavLink className='dropdownsLink' to='dropdowns'>
					Drop Down Menüs
				</NavLink>
			</div>
		</div>
	)
}
